import React, { useState, useRef, useEffect } from "react";
import { DateRange } from "react-date-range";
import { format, subDays } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { enUS } from "date-fns/locale";
import { useQueryParams } from "context/QueryParamsContext";

function CustomdateC({ onRangeSelect }) {
  const [showPicker, setShowPicker] = useState(false);
  const containerRef = useRef(null);
  const { dateRange } = useQueryParams();

  const getValidStartDate = () => {
    return dateRange?.start_date
      ? new Date(dateRange.start_date)
      : subDays(new Date(), 30);
  };

  const getValidEndDate = () => {
    return dateRange?.end_date ? new Date(dateRange.end_date) : new Date();
  };

  const [state, setState] = useState([
    {
      startDate: getValidStartDate(),
      endDate: getValidEndDate(),
      key: "selection",
    },
  ]);

  useEffect(() => {
    const startDate = getValidStartDate();
    const endDate = getValidEndDate();
    setState([{ startDate, endDate, key: "selection" }]);
  }, [dateRange]);

  const handleChange = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setState([ranges.selection]);

    onRangeSelect({
      start: format(startDate, "yyyy-MM-dd"),
      end: format(endDate, "yyyy-MM-dd"),
    });

    setShowPicker(false);
  };

const formattedLabel = `${format(state[0].startDate, "MMMM d, yyyy")} – ${format(
  state[0].endDate,
  "MMMM d, yyyy"
)}`;

  return (
    <div
      ref={containerRef}
      style={{
        position: "relative",
        display: "inline-block",
      }}
    >
<button
  onClick={() => setShowPicker((prev) => !prev)}
           style={{
            padding: "10px 12px",
            borderRadius: "6px",
            background: "#219297",
            color: "white",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            maxWidth: "100%",
            boxShadow:
              "-2px 0 4px rgba(0,0,0,0.05), 2px 0 4px rgba(0,0,0,0.05), 0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: "600",
            transition: "filter 0.3s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.filter = "brightness(1.1)")}
          onMouseLeave={(e) => (e.currentTarget.style.filter = "brightness(1)")}
          >
            {formattedLabel}
          </button>
      {showPicker && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            // left: "-300px",
            marginTop: "20px",
            zIndex: 1000,
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            borderRadius: "8px",
            background: "#fff",
            padding: "0px",
            maxWidth: "100vw",
          }}
        >
          <DateRange
            editableDateInputs={true}
            onChange={handleChange}
            moveRangeOnFirstSelection={false}
            ranges={state}
            locale={enUS}
            maxDate={new Date()}
          />
        </div>
      )}
    </div>
  );
}

export default CustomdateC;
